import SectionCard from "../../SectionCard";
import SectionRow from "../../SectionRow";
import InlineFormSelect from "components/lib-ui/inline-forms/InlineFormSelect";
import InlineFormAutocomplete from "components/lib-ui/inline-forms/InlineFormAutocomplete";
import { GlobalAppDataStorageService } from "infra/storage";
import { RelocationSectionRow } from "./relocation-sections/RelocationSectionRow";


export const LookingFor = ({ candidate }) => {
    const workingModelOptions = GlobalAppDataStorageService.getWorkingModels();
    const jobTypeOptions = GlobalAppDataStorageService.getJobTypes();
    const hardSkillsOptions = GlobalAppDataStorageService.getHardSkills();
    const relocationOptions = GlobalAppDataStorageService.getRelocations();
    const companySizeOptions = GlobalAppDataStorageService.getCompanySizes();
    const {
        companySize,
        jobType,
        jobFunctions,
        preferredSkills,
        otherSkills,
        occupations,
        workModel,
        industries
    } = candidate;

    const industriesOptions = GlobalAppDataStorageService.getIndustries();

    const jobFunctionsOptions = GlobalAppDataStorageService.getJobFunctions();

    const occupationsOptions = GlobalAppDataStorageService.getOccupations();
    
    return (
        <SectionCard title="Looking for">
            <SectionRow title="Working model" fieldKey="working-model">
                <InlineFormSelect
                    multiple
                    fieldName="working_models"
                    options={workingModelOptions}
                    selected={workModel}
                />
            </SectionRow>

            <SectionRow title="Job type" fieldKey="job-type">
                <InlineFormSelect
                    multiple
                    fieldName="job_types"
                    options={jobTypeOptions}
                    selected={jobType}
                />
            </SectionRow>
            <SectionRow title="Preferred industry">
                <InlineFormAutocomplete
                    fieldName="industries"
                    options={industriesOptions}
                    selected={industries}
                    chipAttributes={{
                        sx: { padding: "10px 5px" },
                    }}
                />
            </SectionRow>

            <SectionRow
                title="Preferred job functions"
                fieldKey="preferred-job-functions"
            >
                <InlineFormAutocomplete
                    fieldName="job_functions"
                    options={jobFunctionsOptions}
                    selected={jobFunctions}
                    chipAttributes={{
                        color: "navy",
                        sx: { padding: "10px 5px" },
                    }}
                />
            </SectionRow>

            <SectionRow
                title="Preferred ocupations"
                fieldKey="preferred-occupations"
            >
                <InlineFormAutocomplete
                    fieldName="occupations"
                    options={occupationsOptions}
                    selected={occupations}
                    chipAttributes={{
                        color: "greenCyan",
                        variant: "outlined",
                        sx: { padding: "10px 5px", color: "black" },
                    }}
                />
            </SectionRow>

            <SectionRow title="Preferred skills" fieldKey="preferred-skills">
                <InlineFormAutocomplete
                    fieldName="skills"
                    options={hardSkillsOptions}
                    selected={preferredSkills}
                    extraUpdateData={otherSkills}
                    chipAttributes={{
                        sx: { padding: "10px 5px" },
                    }}
                />
            </SectionRow>
            <RelocationSectionRow
                candidate={candidate}
                options={relocationOptions}
                selected={candidate?.relocationOption}
            />
            
            <SectionRow title="Company size">
                <InlineFormSelect
                    multiple
                    fieldName="company_sizes"
                    options={companySizeOptions}
                    selected={companySize}
                />
            </SectionRow>
            
        </SectionCard>
    );
};

export default LookingFor;
